import React from "react";

function PreviewIcon(props) {
  return (
    <svg
      width={29}
      height={29}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.61" stroke="#095BB8">
        <path
          d="M6.815 13.535c-.102-.162-.153-.243-.182-.367a.88.88 0 010-.336c.029-.124.08-.205.182-.367C7.66 11.13 10.172 7.75 14 7.75c3.83 0 6.341 3.379 7.186 4.715.102.162.153.243.181.367a.88.88 0 010 .336c-.028.124-.08.205-.181.367C20.34 14.87 17.829 18.25 14 18.25c-3.828 0-6.34-3.379-7.185-4.715z"
          stroke="#095BB8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 15.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
          stroke="#095BB8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="0.5" y="0.5" width="26" height="25" rx="12.5" />
      </g>
    </svg>
  );
}

export default PreviewIcon;
